/* eslint-disable @typescript-eslint/no-explicit-any */
import keycloakAdapterEsia, {
  ICfg as IAdapterCfg,
} from '~packages/keycloak-adapter-esia';

export interface ITokenApplyOrgCfg {
  adapterCfg: IAdapterCfg;
  base?: string;
  item: any;
  notifyError?: (msg: string, cfg?: any) => void;
}

export const tokenOrganizationsGet = (keycloak: any) => {
  const tokenParsed = keycloak.idTokenParsed;
  return tokenParsed.organizations
    ? JSON.parse(tokenParsed.organizations)
    : undefined;
};

/**
 *
 * @param cfg
 * @returns
 */
const fn = async ({
  adapterCfg,
  base,
  item,
  notifyError,
}: ITokenApplyOrgCfg) => {
  /*  */
  const { apply } = keycloakAdapterEsia({
    base,
    ...adapterCfg,
  });

  /*  */
  const result = await apply({ esiaOrgId: item.esiaId });
  if (!result.errors) return;

  console.log('esia adapter errors:', result.errors);

  let reqErrorExists = false;

  result.errors.forEach(i => {
    if (i?.code === 'req') {
      reqErrorExists = true;
      notifyError?.('Не удалось выполнить запрос.');
    } else if (typeof i?.message === 'string') {
      notifyError?.(i.message, { details: i.details ?? '', duration: 15 });
    } else {
      console.log('error_', i);
    }
  });

  if (reqErrorExists) {
    // notifyError?.(
    //   'Ошибка! Заполните недостающий реквизит на портале госуслуг и повторите попытку входа.'
    // );
  }
};

export default fn;
